import React from 'react';
import * as Yup from 'yup';

export const SaleOrderStatusValidatorSchema = Yup.object().shape({
    status: Yup.object().required('required')
});